import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cd0af3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "insights-page",
  "aria-labelledby": "user-insights-title"
}
const _hoisted_2 = { class: "insights-page__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "insights-page__eyebrow" }, "Users"),
  /*#__PURE__*/_createElementVNode("h1", { id: "user-insights-title" }, "User insights"),
  /*#__PURE__*/_createElementVNode("p", { class: "insights-page__intro" }, "User growth, onboarding, and saved-workout activity at a glance.")
], -1))
const _hoisted_4 = { class: "insights-page__refresh" }
const _hoisted_5 = {
  key: 0,
  role: "status"
}
const _hoisted_6 = {
  key: 0,
  class: "insights-page__loading",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading user insights…", -1))
const _hoisted_8 = {
  key: 1,
  class: "insights-page__error",
  role: "alert"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Insights could not be loaded", -1))
const _hoisted_11 = {
  key: 2,
  class: "insights-page__content"
}
const _hoisted_12 = {
  class: "insights-metrics",
  "aria-label": "User summary"
}
const _hoisted_13 = { class: "insights-card metric-card" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-card__icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-users" })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Total users", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "All non-deleted registered accounts", -1))
const _hoisted_17 = { class: "insights-card metric-card" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-card__icon metric-card__icon--green",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user-plus" })
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "New users in the last 30 days", -1))
const _hoisted_20 = { class: "insights-card metric-card" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-card__icon metric-card__icon--orange",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check-circle" })
], -1))
const _hoisted_22 = { class: "metric-card__completion" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Profile/onboarding completion rate", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Users who have chosen a username", -1))
const _hoisted_25 = ["aria-valuenow"]
const _hoisted_26 = { class: "insights-card metric-card" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-card__icon metric-card__icon--blue",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bookmark" })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Saved workouts", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Linked to active accounts · selected weeks", -1))
const _hoisted_30 = { class: "insights-card metric-card" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-card__icon metric-card__icon--charcoal",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bolt" })
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Active accounts", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Accounts with at least one saved workout", -1))
const _hoisted_34 = {
  class: "insights-card trend-card",
  "aria-labelledby": "weekly-signup-title"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "insights-page__eyebrow" }, "Growth", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "weekly-signup-title" }, "Weekly signup trend", -1))
const _hoisted_37 = { class: "trend-card__period" }
const _hoisted_38 = {
  class: "trend-card__navigation",
  "aria-label": "Weekly insights period"
}
const _hoisted_39 = { class: "trend-card__chart-scroll" }
const _hoisted_40 = ["aria-label"]
const _hoisted_41 = { class: "trend-card__value" }
const _hoisted_42 = { class: "trend-card__bar-track" }
const _hoisted_43 = ["title"]
const _hoisted_44 = { class: "trend-card__label" }
const _hoisted_45 = {
  class: "insights-card trend-card",
  "aria-labelledby": "weekly-activity-title"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "insights-page__eyebrow" }, "Activity", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "weekly-activity-title" }, "Saved workout activity", -1))
const _hoisted_48 = { class: "trend-card__period" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "trend-card__definition" }, "Anonymous and Quickstart workouts are not included.", -1))
const _hoisted_50 = { class: "trend-card__chart-scroll" }
const _hoisted_51 = ["aria-label"]
const _hoisted_52 = { class: "trend-card__value" }
const _hoisted_53 = { class: "trend-card__bar-track" }
const _hoisted_54 = ["title"]
const _hoisted_55 = { class: "trend-card__label" }
const _hoisted_56 = { class: "trend-card__secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Button, {
        label: "Back to users",
        icon: "pi pi-arrow-left",
        class: "p-button-outlined",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/users')))
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        label: "Refresh",
        icon: "pi pi-refresh",
        disabled: _ctx.loading,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadInsights()))
      }, null, 8, ["disabled"]),
      (_ctx.loadedAt)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Retrieved at " + _toDisplayString(_ctx.loadedAt) + ". Refresh to fetch the latest figures.", 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_ProgressSpinner, { "stroke-width": "3" }),
          _hoisted_7
        ]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", null, [
              _hoisted_10,
              _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
            ]),
            _createVNode(_component_Button, {
              label: "Try again",
              class: "p-button-outlined",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadInsights()))
            })
          ]))
        : (_ctx.insights)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("section", _hoisted_12, [
                _createElementVNode("article", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", null, [
                    _hoisted_15,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatNumber(_ctx.insights.totalUsers)), 1),
                    _hoisted_16
                  ])
                ]),
                _createElementVNode("article", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", null, [
                    _hoisted_19,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatNumber(_ctx.insights.newUsersLast30Days)), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.newUserShare) + "% of all users", 1)
                  ])
                ]),
                _createElementVNode("article", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatPercentage(_ctx.insights.profileCompletionRate)), 1),
                    _hoisted_24,
                    _createElementVNode("div", {
                      class: "metric-card__progress",
                      role: "progressbar",
                      "aria-label": "Profile/onboarding completion rate",
                      "aria-valuemin": "0",
                      "aria-valuemax": "100",
                      "aria-valuenow": _ctx.insights.profileCompletionRate
                    }, [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ width: `${Math.min(_ctx.insights.profileCompletionRate, 100)}%` })
                      }, null, 4)
                    ], 8, _hoisted_25)
                  ])
                ]),
                _createElementVNode("article", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", null, [
                    _hoisted_28,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatNumber(_ctx.insights.savedWorkoutsInPeriod)), 1),
                    _hoisted_29
                  ])
                ]),
                _createElementVNode("article", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", null, [
                    _hoisted_32,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatNumber(_ctx.insights.activeAccountsInPeriod)), 1),
                    _hoisted_33
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_34, [
                _createElementVNode("header", null, [
                  _createElementVNode("div", null, [
                    _hoisted_35,
                    _hoisted_36,
                    _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.selectedPeriodLabel), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_Button, {
                      label: "Older weeks",
                      icon: "pi pi-arrow-left",
                      class: "p-button-outlined p-button-sm",
                      disabled: _ctx.loading || !_ctx.insights.hasOlderWeeks,
                      onClick: _ctx.showOlderWeeks
                    }, null, 8, ["disabled", "onClick"]),
                    _createVNode(_component_Button, {
                      label: "Newer weeks",
                      icon: "pi pi-arrow-right",
                      "icon-pos": "right",
                      class: "p-button-outlined p-button-sm",
                      disabled: _ctx.loading || !_ctx.insights.hasNewerWeeks,
                      onClick: _ctx.showNewerWeeks
                    }, null, 8, ["disabled", "onClick"]),
                    _createElementVNode("span", null, "52 non-overlapping weeks · Monday start · " + _toDisplayString(_ctx.insights.reportingTimeZone), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", {
                    class: "trend-card__chart",
                    role: "img",
                    "aria-label": _ctx.weeklyTrendDescription,
                    style: _normalizeStyle({ '--week-count': _ctx.insights.weeklySignups.length })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.insights.weeklySignups, (week) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: week.weekStart,
                        class: "trend-card__week"
                      }, [
                        _createElementVNode("span", _hoisted_41, _toDisplayString(week.signups), 1),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("span", {
                            class: "trend-card__bar",
                            style: _normalizeStyle({ height: `${_ctx.barHeight(week.signups, _ctx.maxWeeklySignups)}%` }),
                            title: `${_ctx.formatWeekLabel(week.weekStart)}: ${week.signups} signups`
                          }, null, 12, _hoisted_43)
                        ]),
                        _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.formatWeekLabel(week.weekStart)), 1)
                      ]))
                    }), 128))
                  ], 12, _hoisted_40)
                ])
              ]),
              _createElementVNode("section", _hoisted_45, [
                _createElementVNode("header", null, [
                  _createElementVNode("div", null, [
                    _hoisted_46,
                    _hoisted_47,
                    _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.selectedPeriodLabel), 1)
                  ]),
                  _hoisted_49
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", {
                    class: "trend-card__chart",
                    role: "img",
                    "aria-label": _ctx.weeklyActivityDescription,
                    style: _normalizeStyle({ '--week-count': _ctx.insights.weeklySignups.length })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.insights.weeklySignups, (week) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: week.weekStart,
                        class: "trend-card__week trend-card__week--activity"
                      }, [
                        _createElementVNode("span", _hoisted_52, _toDisplayString(week.savedWorkouts), 1),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("span", {
                            class: "trend-card__bar trend-card__bar--activity",
                            style: _normalizeStyle({ height: `${_ctx.barHeight(week.savedWorkouts, _ctx.maxWeeklySavedWorkouts)}%` }),
                            title: `${_ctx.formatWeekLabel(week.weekStart)}: ${week.savedWorkouts} saved workouts from ${week.activeAccounts} active accounts`
                          }, null, 12, _hoisted_54)
                        ]),
                        _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.formatWeekLabel(week.weekStart)), 1),
                        _createElementVNode("span", _hoisted_56, _toDisplayString(week.activeAccounts) + " active", 1)
                      ]))
                    }), 128))
                  ], 12, _hoisted_51)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}